<template>
  <svg
    width="520"
    height="352"
    viewBox="0 0 520 352"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M129.079 28.5128C48.0189 65.4716 -25.5957 146.427 15.1183 257.547C55.8323 368.667 150.049 287.907 230.685 321.644C311.321 355.382 456.705 377.005 488.671 289.948C520.637 202.891 476.787 67.5735 386.015 28.5128C295.243 -10.5479 210.138 -8.44606 129.079 28.5128Z"
      fill="#F7FAFF"
    />
    <g opacity="0.5">
      <rect
        x="23.3066"
        y="207.135"
        width="35.0536"
        height="14.6588"
        stroke="#2E282A"
      />
      <rect
        x="58.3604"
        y="207.135"
        width="35.0536"
        height="14.6588"
        stroke="#2E282A"
      />
      <rect
        x="39.2402"
        y="221.794"
        width="35.0536"
        height="14.6588"
        stroke="#2E282A"
      />
      <rect
        x="39.2402"
        y="251.111"
        width="35.0536"
        height="14.6588"
        stroke="#2E282A"
      />
      <rect
        x="58.3604"
        y="236.453"
        width="35.0536"
        height="14.6588"
        stroke="#2E282A"
      />
    </g>
    <path
      d="M396.789 225.991L323.425 300.824"
      stroke="url(#paint0_linear)"
      stroke-width="1.5"
    />
    <path
      d="M396.789 179.466L323.425 254.298"
      stroke="url(#paint1_linear)"
      stroke-width="1.5"
    />
    <path
      d="M396.789 111.908L323.425 186.74"
      stroke="url(#paint2_linear)"
      stroke-width="1.5"
    />
    <path
      d="M370.117 99.5986L323.425 147.225"
      stroke="url(#paint3_linear)"
      stroke-width="1.5"
    />
    <rect
      x="283.342"
      y="311.021"
      width="123.006"
      height="12.7468"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M283.342 323.768C283.342 323.768 286.347 310.003 303.03 311.021C319.713 312.039 312.012 323.768 326.487 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M292.975 323.768C292.975 323.768 296.678 319.884 303.353 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M308.352 323.768C308.352 323.768 305.772 319.138 299.913 319.138C294.053 319.138 294.911 313.753 299.913 313.753C304.914 313.753 309.81 315.48 311.736 319.138C313.662 322.797 318.359 323.768 318.359 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M323.643 323.768C323.643 323.768 330.918 322.431 336.973 317.359C343.027 312.287 351.892 310.418 356.826 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M331.103 323.768C331.103 323.768 339.175 322.06 342.528 319.71C345.881 317.36 349.756 319.284 351.745 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M317.051 311.021C317.051 311.021 324.261 323.508 337.002 311.021"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M351.744 310.951C351.744 310.951 360.771 314.137 362.099 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M406.348 318.658C406.348 318.658 403.562 320.646 394.752 317.395C385.942 314.143 378.744 314.927 382.343 323.768"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M378.16 323.768C378.16 323.768 372.933 312.236 385.392 310.951"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      d="M375.741 323.768C375.741 323.768 369.131 319.871 363.026 323.768C363.026 323.768 363.427 313.503 374.41 311.021"
      stroke="#2E282A"
      stroke-width="1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M74.5908 83.998C74.5908 69.6386 86.2314 57.998 100.591 57.998H380.007C394.366 57.998 406.007 69.6386 406.007 83.998V267.813C406.007 282.173 394.367 293.813 380.007 293.813H100.591C86.2314 293.813 74.5908 282.173 74.5908 267.813V83.998Z"
      fill="white"
      stroke="#2C2626"
      stroke-width="1.98"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M138.438 229.676C138.438 229.676 142.719 230.699 142.719 225.357C142.719 220.014 142.719 199.692 142.719 199.692L135.67 192.621H116.849L114.182 194.277V199.692H117.663L119.413 201.009L119.877 208.046H135.67L138.438 209.886V229.676Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M135.67 193.267L142.362 199.424L136.035 198.978L135.67 193.267Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M108.456 234.669H144.147C146.117 234.666 147.714 233.07 147.716 231.099V206.83C147.714 204.859 146.117 203.263 144.147 203.26H143.433V199.691C143.433 199.686 143.433 199.681 143.432 199.676L143.432 199.667L143.431 199.644C143.427 199.582 143.415 199.521 143.395 199.463C143.393 199.456 143.39 199.448 143.387 199.441C143.377 199.413 143.365 199.386 143.352 199.36L143.35 199.356C143.335 199.329 143.319 199.303 143.3 199.277C143.296 199.271 143.291 199.265 143.287 199.259C143.267 199.233 143.247 199.209 143.224 199.187L136.086 192.048C136.063 192.026 136.039 192.006 136.014 191.986C136.008 191.982 136.001 191.977 135.995 191.972C135.97 191.954 135.944 191.938 135.916 191.923L135.912 191.921C135.886 191.908 135.859 191.896 135.831 191.885C135.824 191.883 135.817 191.88 135.81 191.878C135.751 191.858 135.69 191.846 135.629 191.842C135.624 191.842 135.62 191.842 135.615 191.841L135.606 191.841C135.602 191.841 135.599 191.841 135.595 191.84L135.595 191.84L135.595 191.84L135.595 191.84C135.591 191.84 135.586 191.839 135.581 191.839H117.022C115.051 191.842 113.455 193.438 113.453 195.408V198.978H108.456C106.486 198.98 104.889 200.576 104.887 202.547V231.099C104.889 233.07 106.486 234.666 108.456 234.669ZM144.146 204.688C145.328 204.689 146.286 205.647 146.288 206.829V231.099C146.286 232.281 145.328 233.239 144.146 233.241H141.291C140.109 233.239 139.151 232.281 139.149 231.099V230.385H139.863C141.834 230.383 143.43 228.787 143.432 226.816V204.688H144.146ZM138.436 198.977H140.996L136.294 194.276V196.836C136.296 198.018 137.254 198.976 138.436 198.977ZM114.88 195.408C114.881 194.226 115.839 193.268 117.021 193.267H134.866V196.836C134.869 198.806 136.465 200.403 138.436 200.405H142.005V226.816C142.003 227.999 141.045 228.957 139.863 228.958H139.149V211.112C139.147 209.142 137.551 207.546 135.58 207.543H120.59V202.547C120.588 200.576 118.991 198.98 117.021 198.977H114.88V195.408ZM108.456 200.405C107.273 200.406 106.315 201.364 106.314 202.547V231.099C106.315 232.281 107.273 233.239 108.456 233.241H138.438C137.972 232.624 137.721 231.872 137.722 231.099V211.112C137.721 209.93 136.763 208.972 135.581 208.971H119.877C119.482 208.971 119.163 208.651 119.163 208.257V202.547C119.161 201.364 118.203 200.406 117.021 200.405H108.456Z"
      fill="black"
    />
    <path
      d="M127.729 203.974C127.729 204.368 128.048 204.688 128.442 204.688H138.436C138.83 204.688 139.15 204.368 139.15 203.974C139.15 203.58 138.83 203.26 138.436 203.26H128.442C128.048 203.26 127.729 203.58 127.729 203.974Z"
      fill="white"
    />
    <path
      d="M123.445 200.405H128.442C128.836 200.405 129.156 200.086 129.156 199.691C129.156 199.297 128.836 198.978 128.442 198.978H123.445C123.051 198.978 122.731 199.297 122.731 199.691C122.731 200.086 123.051 200.405 123.445 200.405Z"
      fill="white"
    />
    <path
      d="M125.587 203.26H124.159C123.765 203.26 123.445 203.58 123.445 203.974C123.445 204.368 123.765 204.688 124.159 204.688H125.587C125.981 204.688 126.301 204.368 126.301 203.974C126.301 203.58 125.981 203.26 125.587 203.26Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M119.955 228.958C119.752 228.958 119.559 228.871 119.423 228.719L114.363 223.065C114.177 222.856 114.129 222.557 114.242 222.301C114.355 222.045 114.608 221.878 114.888 221.875L117.029 221.852L116.943 214C116.938 213.605 117.254 213.282 117.649 213.278L121.932 213.231H121.94C122.331 213.231 122.649 213.546 122.653 213.937L122.74 221.788L124.881 221.765H124.889C125.168 221.765 125.421 221.927 125.537 222.18C125.654 222.433 125.612 222.731 125.431 222.943L120.498 228.708C120.364 228.864 120.169 228.955 119.963 228.958H119.955ZM118.464 222.549C118.469 222.943 118.153 223.266 117.758 223.271L116.477 223.285L119.943 227.16L123.323 223.21L122.041 223.224C121.852 223.226 121.669 223.154 121.533 223.021C121.398 222.888 121.321 222.707 121.32 222.518L121.233 214.666L118.378 214.697L118.464 222.549Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M119.892 227.875L114.88 222.735H117.386V214.219H121.945V222.735H124.873L119.892 227.875Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M200.259 229.676C200.259 229.676 204.54 230.699 204.54 225.357C204.54 220.014 204.54 199.692 204.54 199.692L197.491 192.621H178.671L176.003 194.277V199.692H179.485L181.235 201.009L181.698 208.046H197.491L200.259 209.886V229.676Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M197.491 193.267L204.183 199.424L197.856 198.978L197.491 193.267Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M170.277 234.669H205.968C207.938 234.666 209.535 233.07 209.537 231.099V206.83C209.535 204.859 207.938 203.263 205.968 203.26H205.254V199.691C205.254 199.686 205.254 199.681 205.254 199.676L205.253 199.667L205.252 199.644C205.248 199.582 205.236 199.521 205.216 199.463C205.214 199.456 205.211 199.448 205.209 199.441C205.198 199.413 205.186 199.386 205.173 199.36L205.171 199.356C205.156 199.329 205.14 199.303 205.122 199.277C205.117 199.271 205.113 199.265 205.108 199.259C205.089 199.233 205.068 199.209 205.045 199.187L197.907 192.048C197.885 192.026 197.861 192.006 197.835 191.986C197.829 191.982 197.823 191.977 197.816 191.972C197.791 191.954 197.765 191.938 197.738 191.923L197.733 191.921C197.707 191.908 197.68 191.896 197.652 191.885C197.645 191.883 197.638 191.88 197.631 191.878C197.572 191.858 197.512 191.846 197.45 191.842C197.445 191.842 197.441 191.842 197.436 191.841L197.427 191.841C197.424 191.841 197.42 191.841 197.417 191.84L197.417 191.84L197.417 191.84L197.417 191.84C197.412 191.84 197.407 191.839 197.402 191.839H178.843C176.873 191.842 175.276 193.438 175.274 195.408V198.978H170.277C168.307 198.98 166.71 200.576 166.708 202.547V231.099C166.71 233.07 168.307 234.666 170.277 234.669ZM205.968 204.688C207.15 204.689 208.108 205.647 208.11 206.829V231.099C208.108 232.281 207.15 233.239 205.968 233.241H203.113C201.931 233.239 200.973 232.281 200.971 231.099V230.385H201.685C203.655 230.383 205.252 228.787 205.254 226.816V204.688H205.968ZM200.258 198.977H202.818L198.116 194.276V196.836C198.118 198.018 199.076 198.976 200.258 198.977ZM176.701 195.408C176.703 194.226 177.661 193.268 178.843 193.267H196.688V196.836C196.691 198.806 198.287 200.403 200.257 200.405H203.827V226.816C203.825 227.999 202.867 228.957 201.685 228.958H200.971V211.112C200.969 209.142 199.372 207.546 197.402 207.543H182.412V202.547C182.41 200.576 180.813 198.98 178.843 198.977H176.701V195.408ZM170.277 200.405C169.095 200.406 168.137 201.364 168.136 202.547V231.099C168.137 232.281 169.095 233.239 170.277 233.241H200.26C199.794 232.624 199.543 231.872 199.544 231.099V211.112C199.543 209.93 198.585 208.972 197.403 208.971H181.699C181.304 208.971 180.985 208.651 180.985 208.257V202.547C180.983 201.364 180.025 200.406 178.843 200.405H170.277Z"
      fill="black"
    />
    <path
      d="M189.55 203.974C189.55 204.368 189.869 204.688 190.264 204.688H200.257C200.651 204.688 200.971 204.368 200.971 203.974C200.971 203.58 200.651 203.26 200.257 203.26H190.264C189.869 203.26 189.55 203.58 189.55 203.974Z"
      fill="white"
    />
    <path
      d="M185.268 200.405H190.264C190.659 200.405 190.978 200.086 190.978 199.691C190.978 199.297 190.659 198.978 190.264 198.978H185.268C184.873 198.978 184.554 199.297 184.554 199.691C184.554 200.086 184.873 200.405 185.268 200.405Z"
      fill="white"
    />
    <path
      d="M187.409 203.26H185.981C185.587 203.26 185.268 203.58 185.268 203.974C185.268 204.368 185.587 204.688 185.981 204.688H187.409C187.803 204.688 188.123 204.368 188.123 203.974C188.123 203.58 187.803 203.26 187.409 203.26Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M181.777 228.958C181.573 228.958 181.38 228.871 181.245 228.719L176.185 223.065C175.998 222.856 175.951 222.557 176.064 222.301C176.176 222.045 176.429 221.878 176.709 221.875L178.85 221.852L178.764 214C178.76 213.605 179.076 213.282 179.47 213.278L183.753 213.231H183.761C184.152 213.231 184.47 213.546 184.475 213.937L184.561 221.788L186.702 221.765H186.71C186.989 221.765 187.242 221.927 187.359 222.18C187.475 222.433 187.434 222.731 187.253 222.943L182.319 228.708C182.185 228.864 181.99 228.955 181.784 228.958H181.777ZM180.286 222.549C180.291 222.943 179.975 223.266 179.58 223.271L178.298 223.285L181.765 227.16L185.145 223.21L183.863 223.224C183.674 223.226 183.491 223.154 183.355 223.021C183.22 222.888 183.143 222.707 183.141 222.518L183.055 214.666L180.2 214.697L180.286 222.549Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M181.713 227.875L176.701 222.735H179.207V214.219H183.766V222.735H186.695L181.713 227.875Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M262.081 226.489C262.081 226.489 266.363 227.512 266.363 222.17C266.363 216.827 266.363 196.505 266.363 196.505L259.313 189.434H240.493L237.825 191.09V196.505H241.307L243.057 197.822L243.52 204.859H259.313L262.081 206.699V226.489Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M259.313 190.08L266.006 196.237L259.678 195.791L259.313 190.08Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M232.099 231.482H267.79C269.761 231.479 271.357 229.883 271.359 227.912V203.643C271.357 201.672 269.761 200.076 267.79 200.073H267.077V196.504C267.077 196.499 267.076 196.494 267.076 196.489L267.075 196.48L267.074 196.457C267.07 196.395 267.058 196.334 267.039 196.276C267.036 196.269 267.034 196.261 267.031 196.254C267.021 196.226 267.009 196.199 266.995 196.173L266.993 196.169C266.979 196.142 266.962 196.116 266.944 196.09C266.939 196.084 266.935 196.078 266.93 196.072C266.911 196.046 266.89 196.022 266.868 196L259.729 188.861C259.707 188.839 259.683 188.819 259.658 188.799C259.651 188.795 259.645 188.79 259.638 188.785C259.613 188.767 259.587 188.751 259.56 188.736L259.556 188.734C259.53 188.72 259.502 188.709 259.475 188.698C259.468 188.696 259.461 188.693 259.453 188.691C259.395 188.671 259.334 188.659 259.272 188.655C259.268 188.655 259.263 188.655 259.259 188.654L259.249 188.654C259.246 188.654 259.243 188.654 259.239 188.653L259.239 188.653L259.239 188.653L259.239 188.653C259.234 188.653 259.229 188.652 259.225 188.652H240.665C238.695 188.655 237.098 190.251 237.096 192.221V195.791H232.099C230.129 195.793 228.532 197.389 228.53 199.36V227.912C228.532 229.883 230.129 231.479 232.099 231.482ZM267.79 201.501C268.972 201.502 269.93 202.46 269.931 203.643V227.912C269.93 229.094 268.972 230.052 267.79 230.054H264.935C263.753 230.052 262.795 229.094 262.793 227.912V227.199H263.507C265.477 227.196 267.074 225.6 267.076 223.629V201.501H267.79ZM262.08 195.79H264.639L259.938 191.089V193.649C259.94 194.831 260.898 195.789 262.08 195.79ZM238.523 192.221C238.525 191.039 239.483 190.081 240.665 190.08H258.51V193.649C258.512 195.619 260.109 197.216 262.079 197.218H265.648V223.63C265.647 224.812 264.689 225.77 263.507 225.771H262.793V207.925C262.791 205.955 261.194 204.359 259.224 204.356H244.234V199.36C244.232 197.389 242.635 195.793 240.665 195.791H238.523V192.221ZM232.099 197.218C230.917 197.22 229.959 198.177 229.958 199.36V227.912C229.959 229.095 230.917 230.052 232.099 230.054H262.081C261.616 229.437 261.365 228.685 261.366 227.912V207.925C261.365 206.743 260.407 205.785 259.224 205.784H243.52C243.126 205.784 242.807 205.464 242.807 205.07V199.36C242.805 198.177 241.847 197.22 240.665 197.218H232.099Z"
      fill="black"
    />
    <path
      d="M251.372 200.787C251.372 201.181 251.692 201.501 252.086 201.501H262.079C262.474 201.501 262.793 201.181 262.793 200.787C262.793 200.393 262.474 200.073 262.079 200.073H252.086C251.692 200.073 251.372 200.393 251.372 200.787Z"
      fill="white"
    />
    <path
      d="M247.09 197.218H252.087C252.481 197.218 252.8 196.899 252.8 196.504C252.8 196.11 252.481 195.791 252.087 195.791H247.09C246.696 195.791 246.376 196.11 246.376 196.504C246.376 196.899 246.696 197.218 247.09 197.218Z"
      fill="white"
    />
    <path
      d="M249.231 200.073H247.804C247.409 200.073 247.09 200.393 247.09 200.787C247.09 201.181 247.409 201.501 247.804 201.501H249.231C249.626 201.501 249.945 201.181 249.945 200.787C249.945 200.393 249.626 200.073 249.231 200.073Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M243.599 225.771C243.396 225.771 243.202 225.684 243.067 225.532L238.007 219.878C237.82 219.669 237.773 219.37 237.886 219.114C237.999 218.858 238.251 218.691 238.531 218.688L240.673 218.665L240.586 210.813C240.582 210.418 240.898 210.095 241.292 210.091L245.575 210.044H245.583C245.974 210.044 246.293 210.359 246.297 210.75L246.383 218.601L248.525 218.578H248.533C248.811 218.578 249.064 218.74 249.181 218.993C249.297 219.246 249.256 219.544 249.075 219.756L244.141 225.521C244.007 225.677 243.812 225.768 243.607 225.771H243.599ZM242.108 219.362C242.112 219.756 241.796 220.079 241.402 220.083L240.12 220.098L243.587 223.972L246.967 220.022L245.685 220.036C245.496 220.039 245.313 219.966 245.177 219.834C245.042 219.701 244.965 219.52 244.963 219.33L244.877 211.479L242.022 211.51L242.108 219.362Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M243.536 224.688L238.523 219.548H241.029V211.032H245.589V219.548H248.517L243.536 224.688Z"
      fill="#FF7300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M74.5908 83.998C74.5908 69.6386 86.2314 57.998 100.591 57.998H380.007C394.366 57.998 406.007 69.6386 406.007 83.998V103.886H74.5908V83.998Z"
      fill="#0070E0"
      stroke="#2C2626"
      stroke-width="1.98"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M279.055 182.279C245.047 182.279 217.477 154.704 217.477 120.688C217.477 86.6727 245.047 59.0977 279.055 59.0977C313.064 59.0977 340.634 86.6727 340.634 120.688C340.634 154.704 313.064 182.279 279.055 182.279Z"
      fill="#2C2626"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M274.657 181.179C240.648 181.179 213.078 153.604 213.078 119.589C213.078 85.5731 240.648 57.998 274.657 57.998C308.666 57.998 336.235 85.5731 336.235 119.589C336.235 153.604 308.666 181.179 274.657 181.179Z"
      fill="#44C9C7"
    />
    <path
      d="M244.296 127.518L267.212 146.777L304.758 96.0093"
      stroke="white"
      stroke-width="22"
      stroke-linecap="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M110.601 89.2278C113.593 89.2278 116.018 86.8024 116.018 83.8104C116.018 80.8185 113.593 78.3931 110.601 78.3931C107.609 78.3931 105.184 80.8185 105.184 83.8104C105.184 86.8024 107.609 89.2278 110.601 89.2278Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M135.456 89.2278C138.448 89.2278 140.874 86.8024 140.874 83.8104C140.874 80.8185 138.448 78.3931 135.456 78.3931C132.465 78.3931 130.039 80.8185 130.039 83.8104C130.039 86.8024 132.465 89.2278 135.456 89.2278Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M160.313 89.2278C163.305 89.2278 165.73 86.8024 165.73 83.8104C165.73 80.8185 163.305 78.3931 160.313 78.3931C157.321 78.3931 154.896 80.8185 154.896 83.8104C154.896 86.8024 157.321 89.2278 160.313 89.2278Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M455.104 181.641C469.888 181.641 481.872 169.657 481.872 154.873C481.872 140.09 469.888 128.105 455.104 128.105C440.32 128.105 428.336 140.09 428.336 154.873C428.336 169.657 440.32 181.641 455.104 181.641Z"
      fill="white"
      stroke="#50C65E"
      stroke-width="1.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M244.464 344.163C260.479 344.163 273.463 331.18 273.463 315.164C273.463 299.148 260.479 286.165 244.464 286.165C228.448 286.165 215.465 299.148 215.465 315.164C215.465 331.18 228.448 344.163 244.464 344.163Z"
      fill="white"
      stroke="#FF9800"
      stroke-width="1.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M261.01 300.142C260.972 299.504 260.442 298.998 259.795 298.998H228.154L228.08 299C227.443 299.038 226.937 299.569 226.937 300.216V319.707H228.154V300.825L228.157 300.766C228.186 300.457 228.446 300.216 228.762 300.216H259.187L259.246 300.219C259.554 300.248 259.796 300.508 259.796 300.825V319.707H261.013V300.216L261.01 300.142ZM261.012 323.36V320.925H226.937V323.36L226.939 323.435C226.977 324.073 227.507 324.579 228.154 324.579H259.795L259.869 324.577C260.506 324.539 261.012 324.008 261.012 323.36ZM246.425 325.797C246.509 327.321 246.919 328.522 247.615 329.35L247.704 329.452H240.244C240.964 328.654 241.399 327.482 241.511 325.986L241.523 325.797H246.425ZM251.885 330.67C252.22 330.67 252.493 330.944 252.493 331.279C252.493 331.595 252.251 331.856 251.943 331.886L251.885 331.888H236.064C235.729 331.888 235.455 331.615 235.455 331.279C235.455 330.963 235.697 330.702 236.005 330.673L236.064 330.67H251.885ZM245.8 322.143H242.149C241.813 322.143 241.541 322.416 241.541 322.752C241.541 323.069 241.782 323.329 242.09 323.358L242.149 323.361H245.8C246.136 323.361 246.408 323.088 246.408 322.752C246.408 322.435 246.167 322.175 245.859 322.146L245.8 322.143ZM258.578 301.434V319.707H229.371V301.434H258.578ZM243.778 302.685C243.927 302.634 244.09 302.642 244.234 302.71L254.401 307.499C254.422 307.509 254.444 307.518 254.466 307.528L254.466 307.528C254.507 307.546 254.547 307.564 254.585 307.584C254.797 307.7 254.927 307.927 254.927 308.167V313.431L256.042 315.105L256.074 315.158C256.218 315.431 256.135 315.775 255.873 315.95C255.771 316.019 255.653 316.052 255.536 316.052C255.34 316.052 255.147 315.957 255.029 315.781L254.319 314.714L253.608 315.781L253.566 315.837C253.448 315.977 253.276 316.052 253.101 316.052C252.985 316.052 252.868 316.019 252.764 315.95C252.484 315.763 252.409 315.385 252.595 315.105L253.71 313.431V309.093L251.885 309.953V314.225L251.882 314.287C251.861 314.493 251.736 314.676 251.549 314.77L244.247 318.424L244.181 318.452C244.114 318.476 244.044 318.488 243.974 318.488C243.881 318.488 243.788 318.467 243.702 318.424L236.401 314.77L236.346 314.739C236.172 314.628 236.064 314.435 236.064 314.225V309.953L233.371 308.684L233.319 308.657C233.136 308.548 233.022 308.349 233.022 308.133C233.022 307.898 233.157 307.683 233.371 307.583L243.715 302.71L243.778 302.685ZM250.668 310.527V313.848L243.974 317.198L237.281 313.848V310.527L243.366 313.394V314.834C243.366 315.17 243.638 315.443 243.974 315.443C244.29 315.443 244.55 315.201 244.58 314.893L244.583 314.827L244.583 313.394L250.668 310.527ZM251.597 307.525L243.975 303.934L235.059 308.134L243.974 312.334L251.597 308.743H244.583V309.352L244.58 309.411C244.551 309.72 244.291 309.961 243.975 309.961C243.639 309.961 243.366 309.688 243.366 309.352V306.916L243.369 306.857C243.398 306.548 243.658 306.307 243.975 306.307C244.311 306.307 244.583 306.579 244.583 306.916V307.525H251.597Z"
      fill="#FF9800"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.9989 242.826C46.0146 242.826 58.9978 229.843 58.9978 213.827C58.9978 197.811 46.0146 184.828 29.9989 184.828C13.9833 184.828 1 197.811 1 213.827C1 229.843 13.9833 242.826 29.9989 242.826Z"
      fill="white"
      stroke="#F44336"
      stroke-width="1.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.9989 162.521C46.0146 162.521 58.9978 149.538 58.9978 133.522C58.9978 117.507 46.0146 104.523 29.9989 104.523C13.9833 104.523 1 117.507 1 133.522C1 149.538 13.9833 162.521 29.9989 162.521Z"
      fill="white"
      stroke="#0070E0"
      stroke-width="1.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M457.047 237.41L427.227 220.692C421.576 217.524 416.541 213.365 412.363 208.413C404.144 198.672 399.636 186.339 399.636 173.594V139.646C399.636 139.646 381.332 139.452 379.673 159.249C378.013 179.045 376.896 188.884 376.896 188.884C376.896 188.884 322.936 185.382 316.187 188.049C309.437 190.716 307.643 199.48 314.399 206.558C314.399 206.558 302.129 217.131 311.927 228.214C311.927 228.214 300.069 238.211 311.927 249.161C311.927 249.161 307.667 258.416 311.927 264.923C316.187 271.429 323.552 274.751 343.375 274.751C348.422 274.751 353.931 274.619 359.341 274.421C379.442 273.688 399.485 278.084 416.907 288.135L430.18 295.793L457.047 237.41Z"
      fill="#FFB9B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M425.619 297.84C422.337 296.021 421.073 291.939 422.753 288.585L449.121 235.903C450.769 232.611 454.684 231.158 458.08 232.577L472.757 238.711L438.833 305.165L425.619 297.84Z"
      fill="#0070E0"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M474.465 334.227C474.465 334.227 424.278 317.6 434.504 299.152C444.73 280.705 439.641 273.072 448.677 264.437C457.713 255.803 467.534 249.608 466.682 237.964C465.83 226.319 497.825 240.426 513.097 251.34L474.465 334.227Z"
      fill="white"
    />
    <path
      d="M474.465 334.227C441.007 323.142 427.687 311.451 434.504 299.152C444.73 280.705 439.641 273.072 448.677 264.437C457.713 255.803 467.534 249.608 466.682 237.964C465.83 226.319 497.825 240.426 513.097 251.34"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      d="M376.515 192.543C376.515 192.543 363.986 239.55 397.138 253.728"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      d="M314.284 208.791C314.284 208.791 341.957 215.802 351.593 212.54C361.23 209.278 359.948 194.456 343.144 194.456"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      d="M311.734 230.487C311.734 230.487 338.206 236.046 351.235 232.735C364.264 229.425 358.497 215.843 350.032 214.851"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      d="M311.734 251.183C311.734 251.183 344.284 254.853 354.775 249.717C359.839 247.237 361.649 241.938 358.87 237.545C357.812 235.872 353.32 233.971 353.32 233.971"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <path
      d="M314.284 267.517C314.284 267.517 332.265 271.806 342.975 267.517C353.686 263.229 349.625 253.091 340.025 253.091"
      stroke="#2C2626"
      stroke-width="2.2"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="323.425"
        y1="225.991"
        x2="323.425"
        y2="300.824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5B5154" />
        <stop offset="1" stop-color="#2E282A" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="323.425"
        y1="179.466"
        x2="323.425"
        y2="254.298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5B5154" />
        <stop offset="1" stop-color="#2E282A" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="323.425"
        y1="111.908"
        x2="323.425"
        y2="186.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5B5154" />
        <stop offset="1" stop-color="#2E282A" stop-opacity="0.01" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="323.425"
        y1="99.5986"
        x2="323.425"
        y2="147.225"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5B5154" />
        <stop offset="1" stop-color="#2E282A" stop-opacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
